<form [formGroup]="searchForm">
  <mat-form-field>
    <mat-label>{{ "input-client" | translate }}</mat-label
    ><input
      type="text"
      matInput
      formControlName="client"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option disabled class="loading" *ngIf="loading">
        <mat-spinner diameter="25"></mat-spinner>
      </mat-option>
      <mat-option
        *ngFor="let client of clients$ | async"
        (onSelectionChange)="handleChangeClient($event, client)"
        [value]="client.tradingName"
        class="autocomplete"
      >
        {{ client.tradingName }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="searchForm.controls.client.touched && !searchForm.valid">
      {{ requiredText || "required.client" | translate }}
    </mat-error>
  </mat-form-field>
</form>
